import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import constants from "../../constants";
import http from "../http"; //  this will be used in external apps to detect the app constants.

var getAppConstantsVersion = function getAppConstantsVersion() {
  return constants.API_URL;
};

var getAppConstants = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return http.get("".concat(getAppConstantsVersion(), "/constants"));

          case 2:
            response = _context.sent;
            return _context.abrupt("return", response);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getAppConstants() {
    return _ref.apply(this, arguments);
  };
}();

var getServerTime = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var response;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return http.get("".concat(constants.API_URL, "/current-time"));

          case 2:
            response = _context2.sent;
            return _context2.abrupt("return", response);

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getServerTime() {
    return _ref2.apply(this, arguments);
  };
}();

var uploadImage = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref3) {
    var data, onUploadProgress, response;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            data = _ref3.data, onUploadProgress = _ref3.onUploadProgress;
            _context3.next = 3;
            return http.post("".concat(constants.API_URL, "/assets/images"), data, {
              onUploadProgress: onUploadProgress
            });

          case 3:
            response = _context3.sent;
            return _context3.abrupt("return", response);

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function uploadImage(_x) {
    return _ref4.apply(this, arguments);
  };
}();

var uploadAudio = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref5) {
    var data, response;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            data = _ref5.data;
            _context4.next = 3;
            return http.post("".concat(constants.API_URL, "/assets/audios"), data);

          case 3:
            response = _context4.sent;
            return _context4.abrupt("return", response);

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function uploadAudio(_x2) {
    return _ref6.apply(this, arguments);
  };
}();

export default {
  getAppConstants: getAppConstants,
  getServerTime: getServerTime,
  uploadImage: uploadImage,
  getAppConstantsVersion: getAppConstantsVersion,
  uploadAudio: uploadAudio
};